import {
    noop as _$no,
    createElementVNode as _$ce,
    className as _$cn,
    createVNode as _$cv,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {DropdownMenu} from '../dropdown';
import {getRestProps, findChildren, isComponentVNode} from '../utils';
import {isDropdown} from './useDropdown';
import {makeMenuStyles, makeTitleStyles} from './styles';
import {Icon} from '../icon';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {children, className} = this.get();
    const {collapse, theme, type, size} = (this.rootMenu || this).get();
    const isRootMenu = !this.rootMenu;
    const isDropdownMenu = !isRootMenu && isDropdown(this.rootMenu);
    const classNameObj = {
        'k-menu': true,
        [className]: className,
        [`k-${theme}`]: (isRootMenu || isDropdownMenu) && theme,
        [`k-${size}`]: isRootMenu && size !== 'default',
        'k-collapsed': isRootMenu && collapse,
        [`k-${type}`]: isRootMenu && type,
        [makeMenuStyles()]: true,
    };
    
    const header = (
        (_$blocks['header'] = function($super) {
            return null;
        }),
        (__$blocks['header'] = function($super, data) {
            var block = $blocks['header'];
            var callBlock = function() {
                return _$blocks['header'].call($this, $super, data);
            };
            return block ?
                block.call($this, callBlock, data) :
                callBlock();
        }),
        __$blocks['header'](_$no)
    )
    const content = (
        [
            ($blocks.header) ?
                _$ce(2, 'div', (
                    (!collapse) ?
                        header :
                        findChildren(header, vNode => isComponentVNode(vNode, Icon))
                ), 0, _$cn({
                    'k-menu-header': true,
                    [makeTitleStyles()]: true
                })) :
                undefined,
            children
        ]
    );
    
    return (
        (!isDropdownMenu) ?
            _$cv('div', {
                ...getRestProps(this),
                'className': _$cn(classNameObj)
            }, [
                content,
                null
            ]) :
            _$cc(DropdownMenu, {
                ...getRestProps(this),
                'className': _$cn(classNameObj),
                'children': content
            })
    );
};